
import GreenArrow from "./Assets/GreenArrow.svg";
import RedArrow from "./Assets/RedArrow.svg";
import contentItems from "./contentItems";
export default function News() {
    return (
        <div className="font-custom flex flex-col items-center justify-center ">

            <section className="w-5/6 grid grid-cols-3 gap-4 sm:gap-2 xl:my-10 lg:my-6 md:my-4 sm:my-3 my-2 text-xs sm:text-md md:text-2xl lg:text-xl xl:text-6xl">
                {/* $HYPE Block */}
                <div className="hypeBlock grid grid-cols-3 gap-1 items-center text-white p-1 sm:p-4 md:p-5 ">
                    <div>
                        <p className="">$HYPE</p>
                    </div>
                    <div>
                        <p className="">2679$</p>
                    </div>
                    <div className="grid grid-cols-2 items-center  h-auto justify-center place-items-center">
                        <img src={GreenArrow} alt="" className="w-1.5 sm:w-3 md:w-4 lg:w-5 xl:w-6 h-auto" />
                        <p className="text-[#00CE1F]">66%</p>
                    </div>
                </div>

                {/* $ETH Block */}
                <div className="sethBlock grid grid-cols-3 gap-1 items-center text-white p-3 sm:p-4 md:p-5">
                    <div>
                        <p className="">$ETH</p>
                    </div>
                    <div>
                        <p className="">78$</p>
                    </div>
                    <div className="grid grid-cols-2 items-center  h-auto justify-center place-items-center">
                        <img src={RedArrow} alt="" className="w-1.5 sm:w-3 md:w-4 lg:w-5 xl:w-6 h-auto" />
                        <p className="text-[#FF5353]">36%</p>
                    </div>
                </div>

                {/* $AAPL Block */}
                <div className="applBlock grid grid-cols-3 gap-1 items-center text-white p-3 sm:p-4 md:p-5">
                    <div>
                        <p className="">$AAPL</p>
                    </div>
                    <div>
                        <p className="">15$</p>
                    </div>
                    <div className="grid grid-cols-2 items-center  h-auto justify-center place-items-center">
                        <img src={RedArrow} alt="" className="w-1.5 sm:w-3 md:w-4 lg:w-5 xl:w-6 h-auto" />
                        <p className="text-[#FF5353] ">18%</p>
                    </div>
                </div>
            </section>



            <div className="pb-5" style={{
                width: '85%',
                maxWidth: '1781px',
                margin: '0 auto',
            }}>
                {contentItems.map((item) => (
                    <div key={item.id} style={{
                        position: 'relative',
                        marginBottom: '40px',
                        width: '100%',
                    }}>
                        {/* Контейнер для контента с относительным позиционированием */}
                        <div className='xl:text-6xl lg:text-5xl md:text-4xl sm:text-3xl text-xl' style={{
                            position: 'relative',
                            zIndex: 2,
                            padding: '1.5%',
                            width: '100%',
                            boxSizing: 'border-box',
                        }}>
                            <section className="grid grid-cols-2 gap-0 place-items-center">
                                <img src={item.image} alt="" className="xl:w-full sm:w-5/6 h-auto" />
                                <div className="flex flex-col">
                                    <span className="text-[#979797] mb-1 sm:mb-4 md:mb-6 lg:mb-10 xl:mb-12">
                                        {item.date}
                                    </span>
                                    <span className="text-[#007211] mt-1 sm:mt-4 md:mt-6 lg:mt-10 xl:mt-12">
                                        {item.title}
                                    </span>
                                </div>
                            </section>
                            <p className="mx-3 sm:mx-5 md:mx-8 lg:mx-10 xl:mx-12  pb-4">{item.description}</p>
                        </div>

                        {/* Индивидуальная рамка для каждого элемента */}
                        <svg
                            viewBox="0 0 1781 979"
                            preserveAspectRatio="none" // Изменено на "none" для растягивания
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                zIndex: 1,
                                pointerEvents: 'none'
                            }}
                        >
                            <path
                                d="M13.3167 20.0574C16.8536 20.0574 57.5639 20.0574 110.419 17.0617C142.584 15.2386 203.37 16.4481 236.447 15.8526C269.524 15.2571 273.097 14.066 352.948 13.4524C432.799 12.8389 588.819 12.8389 670.979 13.4344C753.14 14.0299 756.713 15.221 879.439 15.8345C1002.17 16.4481 1243.94 16.4481 1370.27 15.8526C1496.61 15.2571 1500.18 14.066 1513.93 13.4524C1580.77 10.4702 1626.21 9.22961 1667.32 6.23393C1727.46 1.85132 1745.56 2.0111 1761.8 6.17979C1786.56 12.5358 1770.93 66.6889 1773.93 104.099C1777.36 146.898 1773.35 180.019 1771.55 197.362C1768.15 230.017 1772.12 255.814 1773.93 290.427C1775.48 320.241 1774.54 375.064 1775.14 405.67C1775.73 436.276 1776.92 441.041 1777.54 491.733C1778.15 542.425 1778.15 638.9 1777.56 690.386C1776.82 753.958 1772.16 773.092 1770.34 827.718C1769.58 850.338 1764.94 864.55 1763.12 896.98C1762.5 907.99 1760.11 921.071 1758.32 936.104C1755.94 956.152 1710.88 946.408 1682.02 954.222C1654.98 961.547 1630.25 960.845 1606.81 962.668C1584.43 964.409 1558.07 968.064 1506.48 969.887C1488.27 970.53 1456.01 972.9 1413.92 973.496C1393.2 973.789 1341.92 976.51 1269.76 975.914C1240.42 975.672 1218.93 972.9 1189.48 973.496C1173.03 973.828 1124.15 976.51 1055.6 975.914C1027.48 975.67 988.126 972.9 931.608 972.305C905.995 972.035 865.418 969.291 808.9 968.695C783.287 968.426 761.765 965.682 734.12 965.086C723.135 964.85 718.384 963.3 627.201 962.686C536.018 962.073 358.56 962.073 264.761 961.477C170.961 960.881 166.197 959.69 141.709 959.077C73.1739 957.36 24.18 957.272 18.7664 940.579C-6.15263 863.742 10.9348 843.039 9.11218 807.019C8.68069 798.491 7.32569 793.737 6.71215 758.529C6.09861 723.32 6.09861 657.812 6.69411 621.684C7.36868 580.758 9.70768 547.297 9.11218 502.199C8.84594 482.036 6.09861 459.376 5.50311 428.715C5.20636 413.436 2.48954 363.406 3.08504 290.048C3.35219 257.138 6.09861 241.521 6.69411 225.298C9.70768 167.279 10.8987 73.0412 12.7032 58.0808C13.3167 47.8847 13.3167 32.401 13.3167 16.4481"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    stroke: 'black',
                                    strokeWidth: '4 ',
                                    strokeLinecap: 'round',
                                    fill: 'none',
                                    vectorEffect: '' // Сохраняет толщину линии при масштабировании
                                }}
                            />
                        </svg>
                    </div>
                ))}
            </div>



        </div>
    );
}